<template>
  <div>
    <b-container class="bv-example-row">
      <b-row class="bg-dark text-white">
        <b-col sm="12" class=" p-1 text-left">
          <b-row align-h="start">
            <b-col>
              <p class="text-center p-0 m-0">
                © 2021 Seberapa Cepat - Hak Cipta dilindungi oleh Undang-undang
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
